<div
  [class.readonly]="readonly()"
  [class.free-product]="isFreeProduct() && highlightFreeProduct()"
  class="content"
>
  <ui-product-card-core
    [(selected)]="selected"
    [attributesTemplate]="attributesTemplate()"
    [displayListView]="true"
    [enableProductClickTracking]="enableProductClickTracking()"
    [position]="position()"
    [product]="product()"
    [showAttributes]="unavailable() || !isFreeProduct()"
    [showCheckbox]="showCheckbox()"
    [selectable]="selectable()"
  ></ui-product-card-core>

  <div class="col-prices">
    <div class="wrapper-prices">
      @if (unavailable()) {
        <div class="prices-row not-orderable">
          <ui-product-not-orderable></ui-product-not-orderable>
        </div>
      } @else {
        <div class="prices-row quantity">
          <div class="left">Menge</div>
          <div class="right">
            @if (!readonly() && !isFreeProduct()) {
              <ui-form-quantity-counter
                [data]="quantityCounterConfig()"
                [formControl]="quantityCounterControl()"
                [loading]="isQuantityChangeLoading()"
                class="text-bold"
              ></ui-form-quantity-counter>
            } @else {
              <span>{{ productItem().quantity }}</span>
            }
          </div>
        </div>

        @if (isFreeProduct()) {
          <div class="prices-row total-price">
            <div class="left">Gesamtpreis</div>
            <div class="free-label">GRATIS</div>
          </div>
        } @else {
          <ng-template
            uiProductPriceVisibility
            [prices]="displayPrices()"
            let-prices
          >
            <div class="prices-row">
              <div class="left">Einzelpreis</div>
              <div class="right">
                <ui-product-prices
                  [productPrice]="prices"
                  [showThousandthsPlace]="true"
                ></ui-product-prices>
              </div>
            </div>
            <div class="prices-row">
              <div class="left">Preis je VE</div>
              <div class="right">
                <ui-product-prices-formatter
                  [price]="prices.salesUnit"
                  [showThousandthsPlace]="true"
                ></ui-product-prices-formatter>
              </div>
            </div>
            <div class="prices-row total-price">
              <div class="left">Gesamtpreis</div>
              <div class="right">
                <ui-product-prices-formatter
                  [showThousandthsPlace]="false"
                  [price]="totalPrice()"
                  class="total-price"
                ></ui-product-prices-formatter>
              </div>
            </div>
            @if (prices.salesUnitDeposit) {
              <div class="prices-row deposit-price">
                <div class="left">
                  <ui-icon faName="recycle" faStyle="solid"></ui-icon>
                  zzgl. Pfand
                </div>
                <div class="right">
                  <ui-product-prices-formatter
                    [showThousandthsPlace]="false"
                    [price]="totalDeposit()"
                    class="deposit-price"
                  ></ui-product-prices-formatter>
                </div>
              </div>
            }
          </ng-template>
        }
      }
    </div>
  </div>
</div>

@if (showRemove() && !readonly() && !isFreeProduct() && !unavailable()) {
  <div class="wrapper-remove">
    <button
      (click)="removed.emit()"
      [disabled]="isRemoveLoading()"
      class="remove"
    >
      @if (isRemoveLoading()) {
        <ui-icon
          class="spinner"
          faName="spinner-third"
          faStyle="light"
          animation="spin"
        ></ui-icon>
      } @else {
        <ui-icon faName="trash" faStyle="light"></ui-icon>
      }

      Löschen
    </button>
  </div>
}
